import { useRecoilValue, useSetRecoilState } from 'recoil';
import { DependencyContainer } from '../../../DependencyContainer';
import { useFetchData } from '../../../hooks/useFetchData';
import {
  monitorMetadataAtom,
  monitorMetadataLoadingAtom,
} from '../../../state';
import { MonitorMetadata } from '../components/AddMonitor/types';

const { metadataService } = new DependencyContainer();

const useMonitorMetadata = () => {
  const monitorMetadata = useRecoilValue(monitorMetadataAtom);
  const monitorMetadataLoading = useRecoilValue(monitorMetadataLoadingAtom);
  const setMonitorMetadataLoading = useSetRecoilState(
    monitorMetadataLoadingAtom,
  );
  const setMonitorMetadata = useSetRecoilState(monitorMetadataAtom);

  // Fetch available metadata
  const [loading, , error] = useFetchData<MonitorMetadata, any>(
    async () => {
      if (monitorMetadata || monitorMetadataLoading) return;
      setMonitorMetadataLoading(true);
      const data = await metadataService.getMetadata();
      setMonitorMetadataLoading(false);
      setMonitorMetadata(data);
      return data;
    },
    (data) => data,
    [monitorMetadata],
  );

  return { monitorMetadata, loading, error };
};

export default useMonitorMetadata;
